export const filterTimeByAntecedenceHours = (time: string, antecedence: number, currentDate: Date): boolean => {
  const [hours, minutes, _seconds] = time.split(':').map(Number);
  const givenTime = new Date(currentDate);
  givenTime.setHours(hours);
  givenTime.setMinutes(minutes);

  const currentTime = new Date(currentDate);
  currentTime.setHours(currentTime.getHours() + antecedence); // add the antecedence hours to the filter criteria

  return givenTime > currentTime; // will only return the times that are greater than the current time + antecedence
};

const generateSplitTimeArrays = (start: string, end: string) => {
  const startTimes = start.split('/');
  const endTimes = end.split('/');
  const groupedTimes: string[][] = [];

  startTimes.forEach((time, index) => {
    groupedTimes.push([time, endTimes[index]]);
  });

  const timeArray: string[] = [];

  groupedTimes.forEach((group) => {
    const startTime = new Date(`2000-01-01T${group[0]}`);
    const endTime = new Date(`2000-01-01T${group[1]}`);

    while (startTime <= endTime) {
      const formattedTime = startTime.toLocaleTimeString(['pt-br'], { hour: '2-digit', minute: '2-digit' });
      timeArray.push(formattedTime);
      startTime.setMinutes(startTime.getMinutes() + 30);
    }
  });

  return timeArray;
};

export const generateTimeArray = (start: string, end: string): string[] => {
  if (start.includes('/') || end.includes('/')) {
    return generateSplitTimeArrays(start, end);
  }

  const timeArray: string[] = [];
  const startTime = new Date(`2000-01-01T${start}`);
  const endTime = new Date(`2000-01-01T${end}`);

  while (startTime <= endTime) {
    const formattedTime = startTime.toLocaleTimeString(['pt-br'], { hour: '2-digit', minute: '2-digit' });
    timeArray.push(formattedTime);
    startTime.setMinutes(startTime.getMinutes() + 30);
  }

  return timeArray;
};
